import { render, staticRenderFns } from "./table-handler.vue?vue&type=template&id=169ed528&scoped=true&"
import script from "./table-handler.vue?vue&type=script&lang=js&"
export * from "./table-handler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169ed528",
  null
  
)

export default component.exports